import { Component, Input, Output, EventEmitter, Inject } from '@angular/core';
import { AppSettings } from '../../service/app-settings.service';
import { USER_AUTHENTICATION_SERVICE, UserAuthInterface } from 'app/core/services';

declare var slideToggle: any;

@Component({
	selector: 'float-sub-menu',
	templateUrl: './float-sub-menu.component.html',
	standalone: false
})

export class FloatSubMenuComponent {
	@Input() menus;
	@Input() top;
	@Input() left;
	@Input() right;
	@Input() bottom;
	@Input() lineTop;
	@Input() lineBottom;
	@Input() arrowTop;
	@Input() arrowBottom;

	@Output() remainAppSidebarFloatSubMenu = new EventEmitter();
	@Output() hideAppSidebarFloatSubMenu = new EventEmitter();
	@Output() calculateFloatSubMenuPosition = new EventEmitter();

	constructor(public appSettings: AppSettings,
		@Inject(USER_AUTHENTICATION_SERVICE) private _userAuthInterface: UserAuthInterface
	) {
	}

	expandCollapseSubmenu(e, currentMenu, allMenu, active) {
		e.preventDefault();
		var targetItem = (e.target).closest('.menu-item');
		var target = <HTMLElement>targetItem.querySelector('.menu-submenu');
		slideToggle(target);
		this.calculateFloatSubMenuPosition.emit();
	}

	remainMenu() {
		this.remainAppSidebarFloatSubMenu.emit(true);
	}

	hideMenu() {
		this.hideAppSidebarFloatSubMenu.emit(true);
	}
	isChildItemAccessibleArr(list): boolean {
		return list.some(item => item.childSystemNameList && item.childSystemNameList.some(child => this.permissionList.includes(child))
		);
	}

	isChildItemAccessible(item: any) {
		return item.childSystemNameList ? this.permissionList.some(permission => item.childSystemNameList.includes(permission)) : false;
	}

	get permissionList(): Array<string> {
		return this._userAuthInterface.authenticatedUserPermissions;
	}
}
